import { lazy } from "react";
import type { Modul } from "../../kern/modul";

// Erst laden, wenn ein Admin die Zugänge öffnet (BAUPLAN-PAKETE.md, Abschnitt 5.7)
const Zugaenge = lazy(() => import("./Zugaenge").then((m) => ({ default: m.Zugaenge })));
const Schluessel = lazy(() => import("./Schluessel").then((m) => ({ default: m.Schluessel })));

export const zugaenge: Modul = {
  id: "zugaenge",
  name: "Zugänge",
  routen: [
    { pfad: "/zugaenge", seite: Zugaenge, recht: "zugaenge.verwalten" },
    { pfad: "/zugaenge/schluessel", seite: Schluessel, recht: "zugaenge.verwalten" },
  ],
  navigation: [{ bereich: "verwaltung", label: "Zugänge", pfad: "/zugaenge", icon: "zugaenge", recht: "zugaenge.verwalten", reihenfolge: 90 }],
  ereignisse: ["zugaenge.eingeladen", "zugaenge.rolle_geaendert", "zugaenge.admin_geaendert", "zugaenge.aktiviert", "zugaenge.deaktiviert", "zugaenge.mail_geaendert", "zugaenge.redaktion_geaendert"],
};
